module.exports = __webpack_public_path__ + "img/cospirit.1523ecfc.png";